import { render, staticRenderFns } from "./AppQuickLink.vue?vue&type=template&id=39a5a96e&scoped=true&"
import script from "./AppQuickLink.vue?vue&type=script&lang=js&"
export * from "./AppQuickLink.vue?vue&type=script&lang=js&"
import style0 from "./AppQuickLink.vue?vue&type=style&index=0&id=39a5a96e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a5a96e",
  null
  
)

export default component.exports